/* Morfose IM8 tarzı PDP taslağı — davranışlar.
   1) Katman/tek-şişe seçimi → görünümü ve seçili sepet kalemlerini günceller
   2) Saç tipi seçimi → data-sactipi taşıyan metinleri VE 3/2-pack
      kartlarının içeriğini (ürünler, fiyat, kıyas, günlük, hediyeler) değiştirir
   3) Add to Cart (ana düğme + sticky bar düğmesi) → GERÇEK, çoklu ürünlü
      `/cart/add.js` isteği (bkz. im8_taslak.py sepet_kalemleri()) — punch-list
      B6, curl ile gerçek sepette doğrulandı (bkz. rapor). Hiçbir para/yüzde
      matematiği burada YAPILMAZ, yalnızca Python'da önceden hesaplanmış
      `#mf-paket-verisi` JSON'u okunur ve olduğu gibi gönderilir. */
(function () {
  'use strict';

  /* Seçim durumu — modül kapsamında, DOM'dan tekrar okumak yerine tek
     kaynak. sacTipi()/katmanlar() güncelliyor, sepeteEkle() okuyor. */
  var durum = { tip: null, adet: null };

  /* Görev "2 — countdown offer bar" (2026-08-22) — üst "WELCOME OFFER"
     bandının GERÇEK DAYS:HRS:MINS:SECS geri sayımının hedef hesabı.
     Hedef TEK bir yerden değiştirilebilir (HEDEF_GUN/HEDEF_SAAT/
     HEDEF_DAKIKA/HEDEF_SANIYE) — sabit, bir kere geçip biten bir takvim
     tarihi DEĞİL: her hafta `HEDEF_GUN`e (0=Pazar...6=Cumartesi,
     Date.getDay() ile aynı) yuvarlanır, böylece sayfa haftalar sonra
     tekrar açılsa bile hiçbir zaman "süresi geçmiş/negatif" göstermez.

     Buybox-11 — DOM'a hiç bağımlı olmadığı için (yalnız Date matematiği)
     `teklifSayaci()`'nin İÇİNDEN modül kapsamına ÇIKARILDI: hem
     `teklifSayaci()` çağırıyor hem test dosyası (bkz. sonrakiHedef'in
     CommonJS dışa aktarımı, dosyanın sonu) — "bir gün gelecekteki bir
     değişiklik sessizce geçmiş bir zaman damgası üretebilir" riskine
     karşı gerçek bir birim testiyle koruma altına alındı. */
  /* 2026-09-02, kullanıcı kararı: geri sayım 1 GÜNDEN KISA olsun.
     Hedef artık haftalık değil GÜN SONU (bu gece 23:59:59) — yani en
     fazla ~24 saat, ortalama ~12 saat.

     Neden gün sonu, keyfî bir "20 dakika" değil: geri sayım gerçek bir
     sınırı göstermeli. "Bugün" herkes için aynı, doğrulanabilir bir
     sınırdır ve teklif her gün yenilendiği için sayaç sıfırlandığında
     söylenen şey doğru kalır. Ziyaretçiye özel kısa bir pencere (ör.
     her açılışta 20 dakika) tamamen uydurma bir son tarihtir; sayfaya
     ücretli Google Ads trafiği geleceği için bu hem yanıltıcı-teklif
     politikasına hem tüketici mevzuatına açık bir risk olurdu.

     Alt sınır YOK: gece 23:50'de giren kısa bir süre görür. Bunu bir
     tabanla ("2 saatten azsa yarına yuvarla") gizlemek, sayacı yine
     gerçek olmayan bir tarihe bağlamak demekti — bilinçli olarak
     yapılmadı. */
  var HEDEF_SAAT = 23, HEDEF_DAKIKA = 59, HEDEF_SANIYE = 59;

  /* Pencere uzunlugu sayfadan gelir: #mf-offer-countdown[data-pencere-saat].
     Yoksa DAVRANIS DEGISMEZ (gun sonu, 23:59:59) — mevcut iki sayfa aynen
     calisir.

     N saatlik pencere GERCEK bir tekrarlayan takvimdir: gun N saatlik
     dilimlere bolunur (N=8 -> 00:00 / 08:00 / 16:00) ve sayac bir SONRAKI
     dilim sinirina sayar. Ziyaretciye ozel "acilistan itibaren N saat"
     UYGULANMADI: o, her ziyaretcide baska bir son tarih ureten uydurma bir
     aciliktir ve sayfaya ucretli reklam trafigi geldigi icin yaniltici-teklif
     riski tasir (bkz. bu dosyanin ustundeki ayni gerekce). */
  function pencereSaati() {
    // DOM'suz calisabilmeli: sonrakiHedef() Node'da test ediliyor
    // (bkz. TeklifSayaciHedefTesti) ve orada `document` yok.
    if (typeof document === 'undefined' || !document.getElementById) return 0;
    var kutu = document.getElementById('mf-offer-countdown');
    var n = kutu && parseInt(kutu.getAttribute('data-pencere-saat'), 10);
    return (n && n > 0 && n < 24) ? n : 0;
  }

  function sonrakiHedef(simdi) {
    var n = pencereSaati();
    if (n) {
      var hedef = new Date(simdi.getTime());
      hedef.setMinutes(0, 0, 0);
      hedef.setHours((Math.floor(simdi.getHours() / n) + 1) * n);
      return hedef;
    }
    var gunSonu = new Date(simdi.getTime());
    gunSonu.setHours(HEDEF_SAAT, HEDEF_DAKIKA, HEDEF_SANIYE, 0);
    // Gün sonu geçtiyse (yalnız 23:59:59'dan sonraki saniyeler) yarına.
    if (gunSonu <= simdi) gunSonu.setDate(gunSonu.getDate() + 1);
    return gunSonu;
  }

  function paketVerisiOku() {
    var etiket = document.getElementById('mf-paket-verisi');
    if (!etiket) return null;
    try {
      return JSON.parse(etiket.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Seçili paket/saç tipi için Python'da ÖNCEDEN hesaplanmış veri
     kaydını döndürür — tek şişe (adet 1) saç tipinden bağımsız, üst
     seviyede duruyor (bkz. im8_taslak.py buybox_html() js_veri). */
  function seciliVeri() {
    var veri = paketVerisiOku();
    if (!veri) return null;
    if (durum.adet === '1' || durum.adet === 1) return veri['1'];
    if (!durum.tip || !veri[durum.tip]) return null;
    return veri[durum.tip][String(durum.adet)];
  }

  function paketAlanlariniDoldur(id, html) {
    var el = document.getElementById(id);
    /* innerHTML kullanılıyor (textContent DEĞİL): gömülü veri HTML
       varlıkları (&amp;, &middot; vb.) taşıyor. Veri sunucu tarafında
       (Python) üretiliyor, kullanıcı girdisi değil — XSS riski yok. */
    if (el) el.innerHTML = html;
  }

  /* Görev (bu tur), bölüm 12 (launch_event_ep — kapanış paket seçimi):
     buy box'ın pack card'larıyla AYNI fiyat/kıyas/günlük verisini,
     `mf-close-katman-{adet}-*` id namespace'inde de dolduruyor. Element
     yoksa (hedef sayfada yoksa) paketAlanlariniDoldur zaten no-op — bu
     yüzden buy box'ı bozmadan güvenle ekleniyor. */
  var PAKET_ID_ONEKLERI = ['mf-katman-', 'mf-close-katman-'];

  function paketDoldur(tip) {
    var veri = paketVerisiOku();
    if (!veri || !veri[tip]) return;
    ['3', '2'].forEach(function (adet) {
      var v = veri[tip][adet];
      if (!v) return;
      PAKET_ID_ONEKLERI.forEach(function (onek) {
        /* Görev "4/5 — pack card yeniden inşası" (2026-08-22) — SAVE
           rozeti artık yalnızca hediye $ değerini (v.save) DEĞİL,
           referansın "SAVE xx% + FREE WELCOME KIT" kalıbını taşıyor
           (v.saveBadge, Python'da önceden hesaplanmış — burada hiçbir
           yüzde/metin hesabı YOK). */
        paketAlanlariniDoldur(onek + adet + '-save', v.saveBadge);
        paketAlanlariniDoldur(onek + adet + '-fiyat', v.fiyat);
        paketAlanlariniDoldur(onek + adet + '-karsilastirma', v.karsilastirma);
        paketAlanlariniDoldur(onek + adet + '-nitelik', v.nitelik);
        paketAlanlariniDoldur(onek + adet + '-sag', v.sag);
        /* Buybox-11 — kartın günlük-fiyat elemanı `gunlukHtml`'i
           (fiyat + "/day · N days") alır, çıplak `gunluk`'u DEĞİL:
           innerHTML tüm alt içeriği değiştirdiği için çıplak fiyat
           birim/periyot etiketini saç tipi değişiminde silerdi. */
        if (v.gunlukHtml) paketAlanlariniDoldur(onek + adet + '-gunluk', v.gunlukHtml);
      });
      // Fayda/kit listeleri yalnız buy box'ın kendi kartında var — kapanış
      // bloğu bilerek bu iki listeyi tekrarlamıyor (bkz. closing_html
      // docstring'i, "dolgu olurdu").
      paketAlanlariniDoldur('mf-katman-' + adet + '-fayda', v.faydaHtml);
      paketAlanlariniDoldur('mf-katman-' + adet + '-kit', v.kitHtml);
    });
  }

  function katmanlar() {
    var kartlar = document.querySelectorAll('.mf-katman, .mf-tek-sise');
    if (!kartlar.length) return;

    /* Bölüm 12 — kapanış bloğunun pack kartları buy box'takiyle AYNI
       `.mf-katman`/`.mf-tek-sise` class'larını taşıyor, bu yüzden zaten
       yukarıdaki querySelectorAll'a dahiller. Seçim artık DOM node
       kimliğine (`k === kart`) değil `data-adet` DEĞERİNE göre uygulanıyor
       — böylece buy box'ta bir pakete tıklamak kapanış bloğundaki AYNI
       tier'ı da (ve tam tersini) seçili gösterir, ikisi asla farklı bir
       durum göstermez ("must reflect the same selected state, not
       diverge from it"). */
    function sec(kart) {
      var hedefAdet = kart.dataset.adet;
      kartlar.forEach(function (k) {
        var esit = (k.dataset.adet === hedefAdet);
        k.dataset.secili = String(esit);
        var r = k.querySelector('input[type="radio"]');
        if (r) r.checked = esit;
      });
      durum.adet = hedefAdet;
      atcFiyatGuncelle();
      stickyGuncelle();
      costGuncelle();
    }

    kartlar.forEach(function (kart) {
      kart.addEventListener('click', function () { sec(kart); });
    });

    var varsayilan = document.querySelector('.mf-katman[data-varsayilan="true"]') || kartlar[0];
    sec(varsayilan);
  }

  function sacTipi() {
    var dugmeler = document.querySelectorAll('.mf-secenek');
    if (!dugmeler.length) return;

    function uygula(tip) {
      dugmeler.forEach(function (d) {
        d.setAttribute('aria-pressed', String(d.dataset.tip === tip));
      });
      document.querySelectorAll('[data-sactipi]').forEach(function (el) {
        el.hidden = (el.dataset.sactipi !== tip);
      });
      durum.tip = tip;
      paketDoldur(tip);
      atcFiyatGuncelle();
      stickyGuncelle();
      costGuncelle();
    }

    dugmeler.forEach(function (d) {
      d.addEventListener('click', function () { uygula(d.dataset.tip); });
    });
    uygula(dugmeler[0].dataset.tip);
  }

  /* Ana Add to Cart düğmesinin üstündeki fiyatı, seçili paket/saç tipi
     değiştikçe günceller — hiçbir hesap yapmıyor, yalnızca seciliVeri().fiyat. */
  function atcFiyatGuncelle() {
    var v = seciliVeri();
    if (!v) return;
    var fiyatEl = document.getElementById('mf-atc-price');
    if (fiyatEl) fiyatEl.textContent = v.fiyat;
    var stickyPriceEl = document.getElementById('mf-sticky-price');
    if (stickyPriceEl) stickyPriceEl.textContent = v.fiyat;
    // Bölüm 12 (kapanış bloğu) — AYNI seciliVeri().fiyat, üçüncü bir hesap
    // yok (bkz. paketDoldur yorumu).
    var closePriceEl = document.getElementById('mf-close-atc-price');
    if (closePriceEl) closePriceEl.textContent = v.fiyat;
  }

  /* Punch-list B6 — GERÇEK, çoklu ürünlü sepete ekleme. `items` dizisi
     tamamen im8_taslak.py'de önceden hesaplanmış (bkz. sepet_kalemleri()) —
     burada hiçbir varyant id/fiyat/miktar İCAT EDİLMİYOR. Bandana (DRAFT
     durumda, bkz. rapor) bu diziye zaten DAHİL DEĞİL (Python tarafında
     filtrelendi) — /cart/add.js DRAFT bir varyantı içeren isteğin TAMAMINI
     422 ile reddediyor, bu curl ile doğrulandı. */
  function sepeteEkle(durumEl) {
    var v = seciliVeri();
    if (!v || !v.sepetKalemleri || !v.sepetKalemleri.length) return;
    if (durumEl) durumEl.textContent = 'Adding to cart…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: v.sepetKalemleri })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) ||
            'Could not add this set to your cart.';
          if (durumEl) durumEl.textContent = msg;
          return;
        }
        if (durumEl) durumEl.textContent = 'Added to cart.';
        window.location.href = '/cart';
      })
      .catch(function () {
        if (durumEl) durumEl.textContent = 'Network error — please try again.';
      });
  }

  function atcDugmeleri() {
    var ana = document.getElementById('mf-atc-btn');
    var anaDurum = document.getElementById('mf-atc-status');
    if (ana) ana.addEventListener('click', function () { sepeteEkle(anaDurum); });

    var sticky = document.getElementById('mf-sticky-atc');
    if (sticky) sticky.addEventListener('click', function () { sepeteEkle(anaDurum); });

    // Bölüm 12 (kapanış bloğu) — kendi durum satırına yazıyor, ama AYNI
    // sepeteEkle()/seciliVeri() yolunu kullanıyor, ikinci bir sepet mantığı
    // YOK.
    var kapanis = document.getElementById('mf-close-atc');
    var kapanisDurum = document.getElementById('mf-close-atc-status');
    if (kapanis) kapanis.addEventListener('click', function () { sepeteEkle(kapanisDurum); });
  }

  /* Görev 11 (dördüncü tur), Element 1 — güvenilirlik rozetinin galeri
     üzerindeki chip'i. Native galeri (main-product.liquid) Python'dan
     ELE ALINAMAZ (block değil, section'ın kendi Liquid'i) — bu yüzden
     im8_taslak.py `buybox_html`'in bastığı gizli <template
     id="mf-cred-chip-tpl"> içeriğini burada klonlayıp galeri kapsayıcısına
     ekliyoruz. `.product-media-container` sayfada İKİ kez var (görünen
     galeri + gizli quick-view kopyası) — hangisinin GERÇEKTEN görünür
     olduğu yalnız layout çalıştırılarak (getBoundingClientRect().width>0)
     ayırt edilebilir. */
  function credRozeti() {
    var sablon = document.getElementById('mf-cred-chip-tpl');
    if (!sablon || !sablon.content) return;
    var gorunen = null;
    document.querySelectorAll('.product-media-container').forEach(function (el) {
      if (!gorunen && el.getBoundingClientRect().width > 0) gorunen = el;
    });
    if (!gorunen) return;
    var klon = sablon.content.cloneNode(true);
    /* Görev "2 — credibility badge" turu (2026-08-22) — referansın × ile
       kapatılabilir kartı: kapatma düğmesi kartın kendisini (`.mf-cred-
       chip`, klonun kök elemanı) DOM'dan kaldırıyor. Kalıcı bir tercih
       KAYDEDİLMİYOR (localStorage vb.) — sayfa yenilenince kart tekrar
       görünür, referansın kendisi de kalıcılık vaat etmiyor. */
    var kart = klon.querySelector('.mf-cred-chip');
    var kapat = klon.querySelector('.mf-cred-close');
    if (kapat && kart) {
      kapat.addEventListener('click', function () { kart.remove(); });
    }
    gorunen.insertBefore(klon, gorunen.firstChild);
  }

  /* Element 6 (sticky footer) — Alpine'e hiç bağımlı değil: görünürlük düz
     bir IntersectionObserver ile, içerik seçili paket/saç tipi değiştikçe
     stickyGuncelle() ile güncelleniyor.

     Punch-list (2026-08-19) madde 3 — bar tek satırlı, yatay bir düzene
     yeniden kuruldu: isim (statik) + "(Set)" ikinci satır (dinamik), bir
     paket pili (ad+save üstte, günlük fiyat altta) ve sağda fiyat. Burada
     da hiçbir para/yüzde matematiği YAPILMIYOR — yalnızca zaten DOM'da
     render edilmiş ya da Python'da önceden hesaplanmış string'ler
     kopyalanıyor (bkz. test_sticky_guncelle_hicbir_para_matematigi_yapmaz). */
  function stickyGuncelle() {
    var bar = document.getElementById('mf-sticky');
    if (!bar) return;
    var v = seciliVeri();
    if (!v) return;
    var setEl = document.getElementById('mf-sticky-set');
    var packNameEl = document.getElementById('mf-sticky-pack-name');
    var packSaveEl = document.getElementById('mf-sticky-pack-save');
    var packDayEl = document.getElementById('mf-sticky-pack-day');
    var priceEl = document.getElementById('mf-sticky-price');
    var tipDugme = document.querySelector('.mf-secenek[aria-pressed="true"]');

    if (setEl) {
      if (durum.adet === '1') {
        setEl.textContent = '(Single Bottle)';
      } else if (tipDugme) {
        var etiketEl = tipDugme.querySelector('.mf-secenek-metin');
        setEl.textContent = '(' + (etiketEl ? etiketEl.textContent : '') + ' Set)';
      }
    }
    if (packNameEl) {
      if (durum.adet === '1') {
        packNameEl.textContent = 'SINGLE BOTTLE';
      } else {
        var adTutucu = document.querySelector('.mf-katman[data-secili="true"] .mf-katman-ad');
        packNameEl.textContent = adTutucu ? adTutucu.textContent : '';
      }
    }
    /* Görev "4 — SAVE xx% + FREE WELCOME KIT" turu (2026-08-22) — sticky
       bar'ın pili de artık pack card'la AYNI birleşik rozeti (v.saveBadge)
       gösteriyor, yalnız yüzde değil ("anywhere else that currently says
       only 'SAVE xx%'" — görev talimatı). */
    if (packSaveEl) packSaveEl.textContent = v.saveBadge || v.saveYuzde || v.save;
    if (packDayEl && v.gunluk) packDayEl.textContent = v.gunluk + ' USD / day';
    if (priceEl) priceEl.textContent = v.fiyat;
  }

  /* Görev "7 — THE MATH daha çarpıcı olsun" turu (2026-08-22). Kontrolör
     talebi: hero rakamı SEÇİLİ saç tipini/pack'i takip etmeli, sabit Dry
     3-pack'te kalmamalı. `seciliVeri()` (katmanlar()/sacTipi() ZATEN
     güncelliyor) tek kaynak — burada hiçbir para/yüzde/kırılım hesabı
     YAPILMIYOR, yalnızca im8_taslak.py'nin Python'da önceden ürettiği
     `costAmount`/`costSub`/`costKirilim`/`costItemsHtml` alanları
     (bkz. buybox_html() `_js_paket`) DOM'a innerHTML/textContent ile
     kopyalanıyor (bkz. kaynak testi
     test_cost_guncelle_hicbir_para_matematigi_yapmaz).

     Buybox-11 (çift kaçış hatası düzeltmesi, 2026-08-22) — `costSub`
     (`_cost_metin()`den, bkz. im8_taslak.py) seçili saç tipinin etiketini
     GÖMÜLÜ taşır ve icerik.json'daki TÜM metin alanları gibi (bkz.
     `paketAlanlariniDoldur` yorumundaki AYNI kural, satır ~40) HTML
     varlıkları (`&amp;` vb.) ile kodlanmıştır — o varlıklar yalnızca bir
     HTML ayrıştırıcısından geçince (`innerHTML`) çözülür, `textContent`
     onları OLDUĞU GİBİ, kaçışlı basar. `costSub`/`costKirilim` önceden
     `textContent` ile yazılıyordu — "Dry &amp; Damaged" gibi bir etiket
     ekrana LİTERAL `&amp;` olarak düşüyordu (kullanıcı raporu). Fix:
     `costAmount` (yalnız `$` tutarı, hiç varlık taşımaz) `textContent`de
     kalıyor; `costSub`/`costKirilim` artık `innerHTML` — tıpkı
     `costItemsHtml`/`faydaHtml`/`kitHtml`/`nitelik`/`sag` gibi HER YERDE
     zaten uygulanan aynı kural. Veri sunucu tarafında (Python) üretiliyor,
     kullanıcı girdisi değil — XSS riski yok (aynı gerekçe). */
  function costGuncelle() {
    var v = seciliVeri();
    if (!v) return;
    var tutarEl = document.getElementById('mf-cost-amount');
    var altEl = document.getElementById('mf-cost-sub');
    var kirilimEl = document.getElementById('mf-cost-kirilim');
    var breakdownEl = document.getElementById('mf-cost-breakdown');
    if (tutarEl && v.costAmount) tutarEl.textContent = v.costAmount;
    if (altEl && v.costSub) altEl.innerHTML = v.costSub;
    if (kirilimEl) kirilimEl.innerHTML = v.costKirilim || '';
    if (breakdownEl && v.costItemsHtml) breakdownEl.innerHTML = v.costItemsHtml;
  }

  /* Görev "1 — countdown yanlış yerde" turu (2026-08-22) — countdown
     (`.mf-offer`) artık HER ZAMAN görünür, `position:fixed;top:0`
     (bkz. morfose-pdp.css) — topbar'ın kendi `yukseklikOlc()` deseninin
     AYNISI: `--mf-offer-height` CSS değişkenini barın GERÇEK
     `offsetHeight`'ıyla dolduruyor (sabit bir piksel sayısı DEĞİL, iki
     satıra sarsa/mobilde küçülse bile doğru kalır), resize'da yeniden
     ölçülüyor. Bu değişken hem `.mf-topbar`'ı (topbar'ın kendi `top`
     değeri artık `var(--mf-offer-height,0px)`) hem temanın gerçek
     `#sticky-header`'ını aşağı itiyor (bkz. morfose-pdp.css). */
  function teklifYuksekligiOlc() {
    var bar = document.getElementById('mf-offer');
    if (!bar) return;
    var kok = document.documentElement;
    function olc() {
      kok.style.setProperty('--mf-offer-height', bar.offsetHeight + 'px');
    }
    olc();
    window.addEventListener('resize', olc);
  }

  /* Controller düzeltmesi (dokuzuncu tur, item 1) — üst bar artık kalıcı
     görünür DEĞİL: sayfa başında gizli (`transform: translateY(-100%)`,
     bkz. morfose-pdp.css), bir EŞİĞİ geçip aşağı kaydırınca içeri kayıyor,
     yukarı kaydırınca (eşiğin üstünde de olsa) tekrar çıkıyor — hem YÖN
     hem KONUM kontrolü birlikte, salt "scrollY > eşik mi" değil:
       - y <= EŞİK: her zaman gizli (sayfa başında/başına yakınken).
       - y > EŞİK VE yön aşağı: göster.
       - yön yukarı (eşiğin üstünde bile olsa): gizle.
     `<html>` üzerine aynı anda `mf-topbar-acik` sınıfı da ekleniyor —
     morfose-pdp.css'teki güvenlik ağı kuralı (`.mf-topbar-acik
     #sticky-header:not(.header-up){top:var(--mf-topbar-height)}`) bunu
     okuyup temanın kendi başlığını bar açıkken aşağı itiyor, ikisi asla
     aynı y'de üst üste binmiyor. `--mf-topbar-height` barın GERÇEK
     `offsetHeight`'ı (iki satıra sarsa bile doğru kalsın diye ölçülüyor,
     51px gibi sabit bir sayı DEĞİL) — resize'da yeniden ölçülüyor. */
  function topbarKaydirma() {
    var bar = document.getElementById('mf-topbar');
    if (!bar) return;
    var kok = document.documentElement;
    var ESIK = 120;

    function yukseklikOlc() {
      kok.style.setProperty('--mf-topbar-height', bar.offsetHeight + 'px');
    }
    yukseklikOlc();
    window.addEventListener('resize', yukseklikOlc);

    var sonY = window.scrollY || document.documentElement.scrollTop;
    function guncelle() {
      var y = window.scrollY || document.documentElement.scrollTop;
      var asagiMi = y > sonY;
      var acik = (y > ESIK) && asagiMi;
      bar.classList.toggle('mf-topbar--acik', acik);
      kok.classList.toggle('mf-topbar-acik', acik);
      sonY = y;
    }
    window.addEventListener('scroll', guncelle, { passive: true });
  }

  /* Fix 3 (2026-08-21, mobil pass) — Eurus'un native mobil dock'u
     (`#eurus-mobile-dock`, canlı temanın kendi alt navigasyon barı,
     `position:fixed;bottom:0;z-index:30`, yalnızca <768px'te görünür)
     bizim sticky ATC barımızla AYNI köşede oturuyor; bizim z-index'imiz
     (50) yüksek olduğu için barımız onu ÖRTERDİ. `--mf-dock-height`
     CSS değişkenini dock'un GERÇEK `offsetHeight`'ıyla dolduruyoruz
     (morfose-pdp.css `.mf-sticky{bottom:var(--mf-dock-height,0px)}` bunu
     okuyor) — topbar'ın kendi `--mf-topbar-height` ölçme deseniyle AYNI
     teknik. Dock, Eurus'ta `x-cloak` + Alpine `x-teleport="body"` ile
     kuruluyor — sayfa yüklenirken/`alpine:initialized`'dan ÖNCE
     `offsetHeight` 0 dönebilir; 0 gelirse ÖNCEKİ ölçüm KORUNUYOR (aksi
     halde bar dock'un altına inip onu tekrar örterdi). Dock bu
     mağazada/temada hiç yoksa (section boş) fonksiyon hiçbir şey
     yapmaz, CSS'in `0px` varsayılanı geçerli kalır — davranış DEĞİŞMEZ. */
  /* Gerçek 390px ölçümünde (2026-08-22) bulunan defekt: `#eurus-mobile-dock`
     yalnızca bir SARMALAYICI — Eurus asıl barı `x-teleport` ile onun İÇİNE,
     kendi `position:fixed` kabına (`#mobile-dock-container`, 84px) kuruyor.
     Sarmalayıcının `offsetHeight`'ı bu yüzden HER ZAMAN 0 döner, `h > 0`
     koşulu hiç sağlanmaz, `--mf-dock-height` hiç yazılmaz ve bar
     `bottom: 0`'a düşüp 84px'lik dock'un TAM ALTINDA kalır — mobilde
     sepete ekleme barı hiç görünmez. Ölçüm artık sarmalayıcının kendi
     yüksekliği ile içindeki `position:fixed` torunlarının EN BÜYÜĞÜNÜ
     alıyor: iç kabın id'si değişse de doğru kalır, dock hiç yoksa 0. */
  function dockYuksekligi(dock) {
    var h = dock.offsetHeight;
    var ic = dock.querySelectorAll('*');
    for (var i = 0; i < ic.length; i++) {
      if (window.getComputedStyle(ic[i]).position === 'fixed') {
        h = Math.max(h, ic[i].offsetHeight);
      }
    }
    return h;
  }

  function dockYuksekligiOlc() {
    var dock = document.getElementById('eurus-mobile-dock');
    if (!dock) return;
    var kok = document.documentElement;
    function olc() {
      var h = dockYuksekligi(dock);
      if (h > 0) kok.style.setProperty('--mf-dock-height', h + 'px');
    }
    olc();
    window.addEventListener('resize', olc);
    document.addEventListener('alpine:initialized', olc);
    // x-cloak/Alpine ilklenme zamanlaması garantisiz — iki gecikmeli
    // yeniden ölçüm, dock geç render olsa bile boşluğun doğru kalmasını
    // sağlıyor (polling DEĞİL, iki sabit checkpoint).
    setTimeout(olc, 400);
    setTimeout(olc, 1200);
  }

  /* Fix 2 (2026-08-21, kullanıcı raporu) — sticky bar'ın paket pili
     eskiden bir <span>'dı: tıklama işleyicisi/interaktif rol YOKTU ama
     chevron taşıdığı için tıklanabilir GÖRÜNÜYORDU (kullanıcı bunu kırık
     olarak bildirdi). Artık gerçek bir <button> (im8_taslak.py
     sticky_html()) — tıklanınca buy box'ın paket kartlarına (`#mf-
     katmanlar`) kaydırıp ODAKLIYOR. Yeni bir dropdown/seçici UI İCAT
     EDİLMEDİ (tarayıcıda test edilemeden doğrulanamayacak bir risk) —
     mevcut TEK seçim durumuna (katmanlar()'ın kendi `sec()` mantığı)
     yönlendiriyor, ikinci bir durum kaynağı açılmadı. */
  function stickyPaketPili() {
    var pil = document.getElementById('mf-sticky-pack-pill');
    var hedef = document.getElementById('mf-katmanlar');
    if (!pil || !hedef) return;
    pil.addEventListener('click', function () {
      hedef.scrollIntoView({ behavior: 'smooth', block: 'center' });
      hedef.focus({ preventScroll: true });
    });
  }

  /* Bar, gerçek Add to Cart düğmesi görünür alandan çıkınca açılır. */
  /* Gerçek 390px ölçümünde (2026-08-22) bulunan ikinci çakışma: mağaza
     genelindeki pazarlama pop-up'ı (`#popup-minimal-left`, "Are You One of
     Our Winners?", `position:fixed; z-index:50; bottom:1rem; left:1rem`)
     sticky ATC barımızla AYNI köşede ve AYNI z-index'te oturuyor; DOM'da
     sonra geldiği için barın paket pilini ÖRTÜYORDU. Pop-up mağazanın
     kendi öğesi — bu sayfada gizlemek bizim kararımız değil; bunun yerine
     bar açıkken pop-up'ı barın YÜKSEKLİĞİ kadar YUKARI itiyoruz, böylece
     ikisi de kullanılabilir kalıyor. Yükseklik JS'te ölçülüyor (topbar/
     offer/dock ile AYNI desen) — CSS'e sabit bir sayı yazmıyoruz, çünkü
     barın yüksekliği kırılıma ve `env(safe-area-inset-bottom)`'a göre
     değişir. Kök sınıfı (`mf-sticky-acik`) gerekli: pop-up barın torunu
     DEĞİL, seçiciyle ona ancak ortak bir atadan ulaşılıyor. */
  function stickyGorunum() {
    var bar = document.getElementById('mf-sticky');
    var hedef = document.getElementById('mf-atc-wrap');
    if (!bar || !hedef || !('IntersectionObserver' in window)) return;
    var kok = document.documentElement;
    function yukseklikYaz() {
      var h = bar.offsetHeight;
      if (h > 0) kok.style.setProperty('--mf-sticky-height', h + 'px');
    }
    yukseklikYaz();
    window.addEventListener('resize', yukseklikYaz);
    var gozlemci = new IntersectionObserver(function (girdiler) {
      girdiler.forEach(function (g) {
        var acik = !g.isIntersecting;
        bar.classList.toggle('mf-sticky--acik', acik);
        kok.classList.toggle('mf-sticky-acik', acik);
        if (acik) yukseklikYaz();
      });
    }, { threshold: 0 });
    gozlemci.observe(hedef);
  }

  /* Görev 12, bölüm 5 (flavor_quick_add_pro karşılığı) — Milk Therapy
     hattı kartlarının HER biri kendi TEK varyantını, quantity 1 ile
     `/cart/add.js`'e gönderir. Buy box'ın çoklu ürünlü sepetKalemleri
     akışından (sepeteEkle) TAMAMEN ayrı, kasıtlı olarak daha basit bir
     istek — im8_taslak.py quick_add_html()'in bastığı `data-varyant`
     dışında hiçbir veri İCAT EDİLMİYOR. */
  function hizliEkle(dugme) {
    var varyant = dugme.getAttribute('data-varyant');
    if (!varyant) return;
    var kart = dugme.closest('.mf-qa-card');
    var durumEl = kart ? kart.querySelector('.mf-qa-status') : null;
    dugme.disabled = true;
    if (durumEl) durumEl.textContent = 'Adding to cart…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: varyant, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        dugme.disabled = false;
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) ||
            'Could not add this item to your cart.';
          if (durumEl) durumEl.textContent = msg;
          return;
        }
        if (durumEl) durumEl.textContent = 'Added to cart.';
      })
      .catch(function () {
        dugme.disabled = false;
        if (durumEl) durumEl.textContent = 'Network error — please try again.';
      });
  }

  function hizliEkleDugmeleri() {
    document.querySelectorAll('.mf-qa-btn').forEach(function (dugme) {
      dugme.addEventListener('click', function () { hizliEkle(dugme); });
    });
  }

  /* Görev "0/9 — gerçek yorumlar" — "Show more reviews" düğmesi. İlk 2
     yorum kartı sunucu tarafında (im8_taslak.py reviews_html) zaten
     `hidden` OLMADAN render ediliyor (hard-won kural: JS'siz görünürlük);
     kalan kartlar `hidden` niteliğiyle DOM'da duruyor. Düğme yalnızca
     `hidden`'i kaldırır — Alpine'e bağımlı değil, ikinci bir veri
     kaynağı/hesap YOK. */
  function yorumDahaGoster() {
    var dugme = document.getElementById('mf-vr-more');
    var izgara = document.getElementById('mf-vr-grid');
    if (!dugme || !izgara) return;
    dugme.addEventListener('click', function () {
      izgara.querySelectorAll('[data-mf-vr-karti][hidden]').forEach(function (kart) {
        kart.hidden = false;
      });
      dugme.hidden = true;
    });
  }

  /* Görev "2 — countdown offer bar" (2026-08-22) — üst "WELCOME OFFER"
     bandının GERÇEK DAYS:HRS:MINS:SECS geri sayımı. Alpine'e hiç
     bağımlı değil, kendi setInterval'ımız. Hedef hesabı `sonrakiHedef()`
     (modül kapsamında, bkz. dosyanın başı) TEK bir yerden değiştirilebilir
     (HEDEF_GUN/HEDEF_SAAT/HEDEF_DAKIKA/HEDEF_SANIYE) — sabit, bir kere
     geçip biten bir takvim tarihi DEĞİL: her hafta `HEDEF_GUN`e
     (0=Pazar...6=Cumartesi, Date.getDay() ile aynı) yuvarlanır, böylece
     sayfa haftalar sonra tekrar açılsa bile hiçbir zaman "süresi geçmiş/
     negatif" göstermez.

     Buybox-11 (kök neden düzeltmesi) — bant ekranda kalıcı "00:00:00:00"
     gösteriyordu (kullanıcı raporu). Sebep bu fonksiyonun hesabı DEĞİL —
     `kutu` her zaman `null` geliyordu: kapsayıcı `<div>` (im8_taslak.py
     `teklif_html()`) yalnızca `class="mf-offer-countdown"` taşıyordu, `id`
     hiç YOKTU, bu yüzden `getElementById('mf-offer-countdown')` hep boş
     dönüyor ve fonksiyon `if (!kutu) return;` ile SESSİZCE çıkıyordu —
     `sonrakiHedef()` (zaten doğru hesaplıyordu) hiç ÇAĞRILMIYORDU, dört
     rakam da ilk render'daki statik "00" placeholder'da donuk kalıyordu.
     Düzeltme id'yi eklemekti (bkz. teklif_html) — bu fonksiyonun kendisi
     değişmedi. */
  function teklifSayaci() {
    var kutu = document.getElementById('mf-offer-countdown');
    if (!kutu) return;

    function pad(n) { return (n < 10 ? '0' : '') + n; }

    var hedefZaman = sonrakiHedef(new Date());
    var gunEl = document.getElementById('mf-offer-gun');
    var saatEl = document.getElementById('mf-offer-saat');
    var dakikaEl = document.getElementById('mf-offer-dakika');
    var saniyeEl = document.getElementById('mf-offer-saniye');

    function guncelle() {
      var simdi = new Date();
      var kalanMs = hedefZaman - simdi;
      if (kalanMs <= 0) {
        hedefZaman = sonrakiHedef(simdi);
        kalanMs = hedefZaman - simdi;
      }
      var gun = Math.floor(kalanMs / 86400000);
      // Gün hanesi sayfada YOKSA (2026-09-02: hedef gün sonu, gün hep 00
      // olurdu ve kaldırıldı) saat TOPLAM saat olmalı — gün artığından
      // türetilseydi 24 saati aşan bir hedefte sessizce başa sarardı.
      var saat = gunEl ? Math.floor((kalanMs % 86400000) / 3600000)
                       : Math.floor(kalanMs / 3600000);
      var dakika = Math.floor((kalanMs % 3600000) / 60000);
      var saniye = Math.floor((kalanMs % 60000) / 1000);
      if (gunEl) gunEl.textContent = pad(gun);
      if (saatEl) saatEl.textContent = pad(saat);
      if (dakikaEl) dakikaEl.textContent = pad(dakika);
      if (saniyeEl) saniyeEl.textContent = pad(saniye);
    }
    guncelle();
    setInterval(guncelle, 1000);
  }

  /* Görev "10a — hair concerns pill row" (2026-08-22) — referansın
     "Comprehensive body support" pil satırının saç bakımı karşılığı.
     Alpine'e hiç bağımlı değil: tıklanan pil `aria-pressed`e alınır,
     altındaki TEK panel (aynı index) `hidden` KALDIRILARAK gösterilir,
     diğerleri `hidden`e alınır. İlk panel sunucu tarafında zaten
     görünür render edilir (bkz. im8_taslak.py concerns_html()). */
  function endiseSecici() {
    var piller = document.querySelectorAll('.mf-cc-pill');
    if (!piller.length) return;
    var paneller = document.querySelectorAll('[data-cc-panel]');

    function uygula(secilenIndex) {
      piller.forEach(function (p) {
        p.setAttribute('aria-pressed', String(p.dataset.cc === secilenIndex));
      });
      paneller.forEach(function (panel) {
        panel.hidden = (panel.dataset.ccPanel !== secilenIndex);
      });
    }

    piller.forEach(function (p) {
      p.addEventListener('click', function () { uygula(p.dataset.cc); });
    });
  }

  function baslat() {
    katmanlar();
    sacTipi();
    atcDugmeleri();
    credRozeti();
    teklifYuksekligiOlc();
    topbarKaydirma();
    stickyGorunum();
    stickyPaketPili();
    dockYuksekligiOlc();
    hizliEkleDugmeleri();
    yorumDahaGoster();
    teklifSayaci();
    endiseSecici();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  /* Buybox-11 — yalnızca Node'un test koşucusu için: bir tarayıcıda
     `module` global'i hiç TANIMLI DEĞİLDİR (bu dosya düz bir <script>
     olarak yükleniyor, hiçbir bundler/module sistemi yok), bu yüzden
     aşağıdaki blok tarayıcıda HİÇBİR ŞEY yapmadan atlanır — `baslat()`ın
     üstündeki davranış değişmez. Node'da `require()` edildiğinde ise
     CommonJS modül sarmalayıcısı `module`u sağlar ve `sonrakiHedef()`
     hedef-hesap fonksiyonunu (dosyanın başı) test dosyasına, KAYNAĞI
     KOPYALAMADAN, doğrudan dışa aktarır (bkz.
     test_im8_taslak.py TeklifSayaciHedefTesti). */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      sonrakiHedef: sonrakiHedef,
      dockYuksekligi: dockYuksekligi
    };
  }
})();
